export default __webpack_public_path__ + "static/2241-bd49388f5bdd7026bc46ec286489b306.gif";